import type { MailboxInfo } from 'owa-client-types';
import { getDefaultFlags } from '../utils/defaultFlags';

export function getDefaultFeatureFlags(mailboxInfo?: MailboxInfo | null): string[] {
    const defaultFlags = getDefaultFlags(mailboxInfo);
    return Object.keys(defaultFlags).filter(f => defaultFlags[f]);
}
